import { formatMoneyWithCurrency } from "src/utils/numberUtils.ts";
import i18n from "i18next";
import { SalvosCustomerOrderSummary } from "src/api/generated/tenants/salvos/erp/sales/customerOrder/salvosCustomerOrderSummary.ts";
import { CustomerOrderSummary } from "src/api/generated/erp/sales/customerOrder/service/customerOrderSummary.ts";

export const getSalvosCustomerOrderSummaryExtraFields = (summary: CustomerOrderSummary) => {
	if (!("discountMargin" in summary) || !("discountExtraMargin" in summary)) return [];

	const castSummary = summary as SalvosCustomerOrderSummary;

	return [
		{
			label: i18n.t("salvos.discount_margin_short"),
			value: formatMoneyWithCurrency(castSummary.discountMargin, castSummary.currencyCode),
		},
		{
			label: i18n.t("salvos.extra_discount_margin_short"),
			value: formatMoneyWithCurrency(castSummary.discountExtraMargin, castSummary.currencyCode),
		},
	];
};
